import { SydIconsModel } from 'models/shared.models'

const CheckSmall = ({ color }: SydIconsModel) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    {/* <mask id="mask0_7795_14059"  maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
<rect width="24" height="24" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_7795_14059)"> */}
    <path
      d="M10 16.4L6 12.4L7.4 11L10 13.6L16.6 7L18 8.4L10 16.4Z"
      fill={color ?? '#95D357'}
    />
    {/* </g> */}
  </svg>
)

export default CheckSmall
